// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IErrorTrendBucket {
	timeBucket: string | undefined;

	count: number;

	latestFirmwareCount: number;

	$type?: string | undefined;
}
export class ErrorTrendBucket {
	constructor(data?: IErrorTrendBucket) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.timeBucket) { this.timeBucket = new Date(data.timeBucket); }
	}

	timeBucket: Date | undefined = new Date();

	count: number = 0;

	latestFirmwareCount: number = 0;

	static $type: string = "CoreApi.Data.ErrorTrendBucket, ";
	$type?: string | undefined = ErrorTrendBucket.$type;
}

